var map = {
	"./001-african.png": 4579,
	"./002-afro.png": 7810,
	"./003-angry.png": 7099,
	"./004-man.png": 4660,
	"./005-astronaut.png": 8696,
	"./006-bald.png": 6433,
	"./007-beard.png": 9788,
	"./008-bodybuilder.png": 37,
	"./009-boy.png": 6265,
	"./010-general.png": 4724,
	"./011-cosplay.png": 2063,
	"./012-cowboy.png": 7649,
	"./013-cyclist.png": 6070,
	"./014-woman.png": 3968,
	"./015-designer.png": 5722,
	"./016-DJ.png": 419,
	"./017-driver.png": 8443,
	"./018-farmer.png": 9783,
	"./019-gentleman.png": 1911,
	"./020-grandfather.png": 6192,
	"./021-grandmother.png": 9731,
	"./022-hipster.png": 3135,
	"./023-indian.png": 4093,
	"./024-labour.png": 324,
	"./025-lady.png": 1872,
	"./026-lady.png": 1350,
	"./027-lady.png": 4348,
	"./028-african.png": 6603,
	"./029-mountaineer.png": 7398,
	"./030-nurse.png": 1156,
	"./031-police.png": 6264,
	"./032-professor.png": 7082,
	"./033-programmer.png": 5870,
	"./034-punk.png": 9455,
	"./035-tailor.png": 2263,
	"./036-lady.png": 9843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9494;